import { render, staticRenderFns } from "./TypeSelect.vue?vue&type=template&id=b96872d6&scoped=true&"
import script from "./TypeSelect.vue?vue&type=script&lang=ts&"
export * from "./TypeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TypeSelect.vue?vue&type=style&index=0&id=b96872d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96872d6",
  null
  
)

export default component.exports